import { showToast } from '../../../../lib/toast';

export const toastForAdminPasswordCopy = () => {
  showToast({
    title: 'Admin password coppied to clipboard',
    type: 'success',
  });
};

export const toastForAdminUserPasswordCopySuccess = () => {
  showToast({
    title: 'Admin user password coppied to clipboard',
    type: 'success',
  });
};

export const toastForAdminUserPasswordGeneratedSuccess = () => {
  showToast({
    title: 'Admin user password generated successfully',
    type: 'success',
  });
};
